@if (folder) {
  <app-folder-editform [editedFolder]="folder">
  </app-folder-editform>
}
